export const isPlainEmptyObject = (value) => (
  value &&
  typeof value === 'object' &&
  !Array.isArray(value) &&
  Object.keys(value).length === 0
);

export const getEntityId = (value) => {
  if (!value || isPlainEmptyObject(value)) return '';
  if (typeof value === 'object') {
    const nestedPlayerId = value.playerId;
    const id = value._id || value.id || nestedPlayerId?._id || nestedPlayerId?.id || nestedPlayerId;
    return typeof id === 'object' ? '' : String(id || '');
  }
  return String(value || '');
};

export const getPlayerName = (player) => {
  if (!player || isPlainEmptyObject(player)) return 'Unknown player';
  if (typeof player === 'string') return player;
  return (
    player.personal?.fullName ||
    player.profile?.fullName ||
    player.fullName ||
    player.name ||
    player.displayName ||
    player.user?.name ||
    'Unknown player'
  );
};

export const getUserName = (user) => {
  if (!user || isPlainEmptyObject(user)) return 'Unknown user';
  if (typeof user === 'string') return user;
  return (
    user.name ||
    user.fullName ||
    user.displayName ||
    user.personal?.fullName ||
    'Unknown user'
  );
};

export const normalizeRosterPlayer = (player, index = 0) => {
  const id = getEntityId(player) || `${getPlayerName(player)}-${index}`;
  return {
    id,
    name: getPlayerName(player),
    imageUrl: player?.imageUrl || player?.personal?.imageUrl || player?.profileImage || '',
    playingRole: player?.playingRole || player?.skills?.primaryRole || 'Player',
    maskedEmail: player?.maskedEmail || '',
    maskedMobile: player?.maskedMobile || '',
    raw: player,
  };
};
